import { render, staticRenderFns } from "./SignReward.vue?vue&type=template&id=edbaf1c2&scoped=true&"
import script from "./SignReward.vue?vue&type=script&lang=js&"
export * from "./SignReward.vue?vue&type=script&lang=js&"
import style0 from "./SignReward.vue?vue&type=style&index=0&id=edbaf1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbaf1c2",
  null
  
)

export default component.exports